// Global announcement banner shown at the top of every hub when the super
// admin flips the switch in Master Styles > announcement.
import { useGlobalConfig } from "@/contexts/GlobalConfigContext";
import { Megaphone } from "lucide-react";

export default function AnnouncementBanner() {
  const { config } = useGlobalConfig();
  const ann = config?.announcement;
  if (!ann?.active || !ann?.text) return null;
  return (
    <div
      data-testid="announcement-banner"
      className="bg-amber-50 border-b border-amber-200 text-amber-900 md:ml-[var(--bh-sidebar-w,16rem)] transition-[margin] duration-300"
    >
      <div className="px-6 md:pl-10 md:pr-6 h-9 flex items-center gap-2 text-xs">
        <Megaphone className="w-3.5 h-3.5" strokeWidth={2} />
        <span>{ann.text}</span>
      </div>
    </div>
  );
}
